module.exports = __webpack_public_path__ + "static/leading-voice-in-radio-65fa3453efcb1ada9f7c98241799e0e9.jpg";